import { VERSION } from '../../version';

/**
 * Set by the bundle build: true → the widget comes from the separate
 * `configento-altcha.js` next to the bundle; false (tests, dev server) →
 * imported directly. The false branch is dropped from the build, so the
 * widget's code never lands in `configento.js`.
 */
declare const __CFG_ALTCHA_EXTERNAL__: boolean;

// Captured while the bundle's own <script> is executing — afterwards
// document.currentScript is null. Also right for script tags a loader
// inserts dynamically (Shopify).
const bundleSrc = typeof document !== 'undefined'
    ? (document.currentScript as HTMLScriptElement | null)?.src ?? ''
    : '';

let loading: Promise<void> | null = null;

/** Make `<altcha-widget>` available; resolves once the element is defined. */
export function loadAltcha(): Promise<void> {
    if (!__CFG_ALTCHA_EXTERNAL__) {
        return import('../../altcha-entry').then(() => undefined);
    }
    if (customElements.get('altcha-widget')) return Promise.resolve();
    loading ??= new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.src = altchaUrl();
        script.async = true;
        script.onload = () => {
            customElements.whenDefined('altcha-widget').then(() => resolve(), reject);
        };
        script.onerror = () => {
            loading = null;
            reject(new Error(`could not load ${script.src}`));
        };
        document.head.appendChild(script);
    });
    return loading;
}

function altchaUrl(): string {
    const base = bundleSrc || 'https://cloud.configento.app/configento-v3/configento.js';
    return new URL(`configento-altcha.js?v=${VERSION}`, base).href;
}
